import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  forwardRef,
  inject,
} from '@angular/core';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavigationItemInterface } from '../models/navigation-item-interface';
import { NgClass } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';
import { NavCollapsableComponent } from '../nav-collapsable/nav-collapsable.component';
import { NavItemComponent } from '../nav-item/nav-item.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-nav-group',
  styleUrls: ['./nav-group.component.scss'],
  templateUrl: './nav-group.component.html',
  imports: [
    NgClass,

    TranslateDirective,
    // forwardRef breaks the circular ES module evaluation with NavCollapsableComponent
    forwardRef(() => NavCollapsableComponent),
    NavItemComponent,
  ],
})
export class NavGroupComponent implements OnInit, OnDestroy {
  @HostBinding('class') public classes = 'nav-group nav-item';
  @Input() public item: NavigationItemInterface;

  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _fuseNavigationService = inject(FuseNavigationService);
  private _unsubscribeAll: Subject<void>;

  public constructor() {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  public ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  public ngOnInit(): void {
    // Subscribe to navigation item
    merge(
      this._fuseNavigationService.onNavigationItemAdded,
      this._fuseNavigationService.onNavigationItemUpdated,
      this._fuseNavigationService.onNavigationItemRemoved,
    )
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
  }
}
